import searchModel from '../data/searchModel';
export default function filterOptions(query) {
    return searchModel()
        .search(query)
        .map(function (result) { return result.option; });
}
//# sourceMappingURL=filterOptions.js.map